import { Hyperlink } from '@THC/components/Hyperlink';
import { NewTabIcon } from '@THC/components/Icons';
import { IconText } from '@THC/components/IconText';

import { triggerAiCompanionVehicleLinkClickedEvent } from 'Services/analytics/events/aiCompanionEvents';

export const renderer = {
	link(href: string, text: string) {
		return (
			<Hyperlink
				href={`${href}?utm_source=${encodeURIComponent(window.location.href)}`}
				label={<IconText reverse icon={NewTabIcon} text={text} />}
				onClick={() => triggerAiCompanionVehicleLinkClickedEvent(href)}
				rel="noopener"
				target="_blank"
			/>
		);
	},
};
